import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";

export default function Header({ onLogout, user }) {
  const [open, setOpen] = useState(false);

  const baseLink = "px-3 py-2 rounded-md text-sm font-semibold whitespace-nowrap";
  const active = "bg-worthblue text-white";
  const inactive = "text-worthblue hover:bg-gray-100";

  const getClass = ({ isActive }) => `${baseLink} ${isActive ? active : inactive}`;

  const role = user?.role || "";
  const canConfig = role === "admin" || role === "captura";

  return (
    <header className="w-full bg-white border-b sticky top-0 z-30">
      <div className="max-w-6xl mx-auto px-3 py-2 flex items-center justify-between gap-3">
        <Link to="/bienvenida" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-xl bg-worthblue text-white flex items-center justify-center font-extrabold">W</div>
          <div className="leading-tight">
            <div className="font-extrabold text-worthblue">Worth Pagos</div>
            <div className="text-xs text-gray-500">
              {user?.username ? `${user.username} · ${role}` : "Control de pagos"}
            </div>
          </div>
        </Link>

        <button
          className="md:hidden border rounded px-2 py-1 text-worthblue"
          onClick={() => setOpen((v) => !v)}
          aria-label="Abrir menú"
        >
          ☰
        </button>

        <nav className={`${open ? "flex" : "hidden"} md:flex flex-col md:flex-row md:items-center gap-2`}>
          <NavLink to="/bienvenida" className={getClass} onClick={() => setOpen(false)}>Inicio</NavLink>
          <NavLink to="/calendario" className={getClass} onClick={() => setOpen(false)}>Calendario</NavLink>
          <NavLink to="/captura" className={getClass} onClick={() => setOpen(false)}>Captura</NavLink>
          <NavLink to="/grafica" className={getClass} onClick={() => setOpen(false)}>Proyección</NavLink>
          {canConfig && (
            <NavLink to="/configuracion" className={getClass} onClick={() => setOpen(false)}>Configuración</NavLink>
          )}

          {onLogout && (
            <button
              className="ml-0 md:ml-2 px-3 py-2 rounded-md text-sm font-semibold text-red-700 hover:bg-red-50 border md:border-0"
              onClick={() => {
                setOpen(false);
                onLogout();
              }}
            >
              Cerrar sesión
            </button>
          )}
        </nav>
      </div>
    </header>
  );
}
